<template>
  <div>
    <h3>Resources</h3>
    <ul class="mt-3">
      <li class="border-t border-black py-3" v-for="(resource, count) in resources" :key="count">
        <a :href="resource.url" class="flex items-center" target="_blank">
          <div v-if="resource.type === 'document'"
            class="mr-6 f-serif uppercase border text-sm border-black pb-2 pt-3 px-5">
            {{ resource.extension }}
            <BaseArrowDown class="blink mx-auto my-2" />
          </div>
          <div class="flex-1 text-right">
            <span v-html="getFieldByLang(resource, 'caption', lang)" />
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {

  name: 'BaseResources',

  data () {
    return {

    }
  },
  props: ['resources'],
  computed: {
    ...mapState(['lang', 'cats'])
  },
}
</script>

<style lang="stylus" scoped>
  a:hover
    .blink
      animation: pulse 0.75s infinite

  @keyframes pulse
    0%
      transform: translateY(0px)
    48%
      transform: translateY(4px)
    52%
      transform: translateY(4px)
    100%
      transform: translateY(0)

</style>
